var render, staticRenderFns
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296b2c3e')) {
      api.createRecord('296b2c3e', component.options)
    } else {
      api.reload('296b2c3e', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/ImageSlider.vue"
export default component.exports